import React from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import zhs from "date-fns/locale/zh-CN"; // the locale you want
import zht from "date-fns/locale/zh-TW";
import { getBaseFormattedDate } from "utils/DateTimeUtils";
import './CustomDatePicker.scss';
registerLocale("zh-Hans", zhs); // register it with the name you want
registerLocale("zh-Hant", zht);

const CustomDatePicker = ({
  language,
  selectedDate,
  onSelected,
  placeholder = "",
  maxDate = null,
  customClassName = "",
}) => {
  const CustomDatePickerInput = ({ value, onClick }) => (
    <div className="custom-react-date-picker-input-container">
      <input
        type="text"
        className="custom-react-date-picker-input"
        placeholder={placeholder}
        onClick={onClick}
        value={value ? getBaseFormattedDate(value) : null}
        readOnly
      />
      <img
        alt=""
        src="/records/calendar/calendar.png"
        srcSet="/records/calendar/calendar@2x.png 2x, /records/calendar/calendar@3x.png 3x"
        className="custom-react-date-picker-calendar"
        onClick={onClick}
      />
    </div>
  );


  return (
    <div className={`custom-react-date-picker-container ${customClassName}`}>
      <DatePicker
        wrapperClassName="custom-react-date-picker"
        locale={language}
        dateFormat="yyyy-MM-dd"
        maxDate={maxDate}
        selected={selectedDate}
        onChange={onSelected}
        customInput={<CustomDatePickerInput />}
      />
    </div>
  )
}

export default CustomDatePicker;
